export default {
	billing: 'Billing',
	helpCenter: 'Help',
	motorwayPay: 'Motorway Pay',
	pricing: 'Pricing',
	signout: 'Sign out',
	trade: 'Your listings',
	wallet: 'Wallet',
};
